import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]

  connect() {
    this.initializeSortable()
  }

  initializeSortable() {
    try {
      this.sortable = Sortable.create(this.element, {
        handle: '.drag-handle',
        animation: 150,
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        onStart: (event) => {
          event.item.classList.add('bg-blue-50', 'border-blue-300')
        },
        onEnd: (event) => {
          event.item.classList.remove('bg-blue-50', 'border-blue-300')
          this.updatePositions()
        }
      })
    } catch (error) {
      // Error initializing Sortable
    }
  }

  updatePositions() {
    const items = this.element.querySelectorAll('[data-competency-id]')
    
    items.forEach((item, index) => {
      const competencyId = item.dataset.competencyId
      let positionInput = item.querySelector('input[name*="[position]"]')
      
      if (!positionInput) {
        positionInput = document.createElement('input')
        positionInput.type = 'hidden'
        positionInput.name = `competency_requirements[${competencyId}][position]`
        positionInput.value = index + 1
        item.appendChild(positionInput)
      } else {
        positionInput.value = index + 1
      }
    })
  }
}